import React from 'react'

import {
  ItemSelector,
  type ItemSelectorProps,
} from '~/components/elements/ItemSelector'
import { type Question } from '~/hooks/useSurveyQuery'
import { QuestionOp } from '~/utils'

type QuestionSelectorItem = {
  question: Question
  name: string
}

export type QuestionSelectorProps = Pick<ItemSelectorProps, 'onBlur'> & {
  value: Question['question_id'] | null
  questions: Question[]
  onChange?: (question: Question['question_id']) => void
}

export const QuestionSelector = React.forwardRef<
  HTMLSpanElement,
  QuestionSelectorProps
>(({ onChange, questions, value: valueProp, ...rest }, ref) => {
  const data = React.useMemo(
    () =>
      questions.map((question) => ({
        question,
        name: QuestionOp.toText(question),
      })),
    [questions],
  )

  const value = React.useMemo(
    () => data.find((item) => item.question.question_id === valueProp),
    [data, valueProp],
  )

  const handleChange = React.useCallback<EH<ItemSelectorProps, 'onChange'>>(
    (item: QuestionSelectorItem) => {
      onChange?.(item.question.question_id)
    },
    [onChange],
  )

  return (
    <ItemSelector
      ref={ref}
      data={data}
      dataItemKey="question"
      textField="name"
      value={value}
      width={240}
      onChange={handleChange}
      {...rest}
    />
  )
})
